// ============================================================================
// RefreshButton — força pull do cloud e atualiza todos os dados em tela
// ============================================================================
// Visível pra todos (admin e profissional). Útil quando o admin cria um
// desafio em um dispositivo e o profissional precisa puxar a versão nova
// no celular. Fora isso, o sync já é feito automaticamente no startup.
// ============================================================================

import React, { useState } from 'react';
import { RefreshCw, Check, X as XIcon } from 'lucide-react';
import { useData } from '../contexts/DataContext.jsx';
import { useAvecSync } from '../contexts/AvecSyncContext.jsx';

export default function RefreshButton() {
  const { refreshFromCloud } = useData();
  const avec = useAvecSync();
  const [state, setState] = useState('idle'); // idle | loading | success | error

  const handleClick = async () => {
    if (state === 'loading') return;
    setState('loading');
    try {
      // Faz os dois em paralelo: pull do Supabase + sync da Avec (mensal + diário)
      await Promise.all([
        refreshFromCloud(),
        avec.refreshAll ? avec.refreshAll() : Promise.resolve(),
      ]);
      setState('success');
      setTimeout(() => setState('idle'), 1800);
    } catch {
      setState('error');
      setTimeout(() => setState('idle'), 2200);
    }
  };

  const Icon = state === 'success' ? Check : state === 'error' ? XIcon : RefreshCw;
  const colorClass =
    state === 'success' ? 'text-green-400'
    : state === 'error' ? 'text-red-400'
    : 'text-[#8C9CB5] hover:text-[#E9EEF5]';
  const animClass = state === 'loading' ? 'animate-spin' : '';

  return (
    <button
      onClick={handleClick}
      title="Atualizar dados do servidor"
      aria-label="Atualizar dados"
      className={`relative p-2 rounded-lg hover:bg-white/5 transition-colors ${colorClass}`}
    >
      <Icon size={18} className={animClass} />
    </button>
  );
}
